"use strict";

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeValue = exports["default"] = exports.ThemeStore = exports.ThemeContext = void 0;

var _templateParsers = require("../utils/templateParsers");

var React = _interopRequireWildcard(require("react"));

var defaultTheme = _interopRequireWildcard(require("../constants/theme.json"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ThemeContext = /*#__PURE__*/(0, React.createContext)({});
exports.ThemeContext = ThemeContext;

var getThemeValue = function getThemeValue(props) {
  var themeData = JSON.parse(JSON.stringify(props));
  var parsedThemeData = (0, _templateParsers.parseTheme)(themeData);
  var style = "normal";
  var Value = {
    parsedTheme: parsedThemeData,
    style: style,
    theme: themeData
  };
  return Value;
};

exports.getThemeValue = getThemeValue;

var ThemeStore = function ThemeStore(_ref) {
  var userTheme = _ref.userTheme,
      children = _ref.children,
      _ref$readLocal = _ref.readLocal,
      readLocal = _ref$readLocal === void 0 ? false : _ref$readLocal,
      localData = _ref.localData,
      env = _ref.env,
      project = _ref.project;
  var style = "normal";

  var _useState = (0, React.useState)(function () {
    return getThemeValue(defaultTheme);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      themeData = _useState2[0],
      setThemeData = _useState2[1];

  (0, React.useEffect)(function () {
    if (userTheme) {
      var getClientThemeFile = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(clientName) {
          var themeLink, _yield$axios$get, data, parsedThemeData;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  themeLink = project === "catering" ? "https://assets.lunchbox.io/".concat(clientName, "/catering/theme-").concat(env, ".json") : "https://assets.lunchbox.io/".concat(clientName, "/data/theme-").concat(env, ".json");
                  _context.prev = 1;
                  _context.next = 4;
                  return _axios["default"].get(themeLink);

                case 4:
                  _yield$axios$get = _context.sent;
                  data = _yield$axios$get.data;
                  parsedThemeData = (0, _templateParsers.parseTheme)(data);
                  setThemeData({
                    parsedTheme: parsedThemeData,
                    style: style,
                    theme: data
                  });
                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](1);
                  console.error("no theme file on server");

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 10]]);
        }));

        return function getClientThemeFile(_x) {
          return _ref2.apply(this, arguments);
        };
      }();

      getClientThemeFile(userTheme);
    }
  }, [userTheme, env, project]);
  (0, React.useEffect)(function () {
    if (readLocal) {
      var parsedThemeData = (0, _templateParsers.parseTheme)(localData);
      setThemeData({
        parsedTheme: parsedThemeData,
        style: style,
        theme: localData
      });
      return;
    }
  }, [readLocal]);
  var contextValue = {
    userTheme: userTheme,
    themeData: themeData,
    setThemeData: setThemeData,
    getThemeValue: getThemeValue
  };
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: contextValue
  }, typeof children === "function" ? React.Children.only(children(contextValue)) : React.Children.only(children));
};

exports.ThemeStore = ThemeStore;
var _default = ThemeStore;
exports["default"] = _default;